import instance from "@/utils/require.js"

// 虚拟物料UUID--分页查询
export function apiUuidSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/uuid/search",
		method: "post",
		data
	})
}
export function apiTuyaItemCodeList(data = {}) {
	return instance({
		url: "/aim/api/v3/item_code/tuya",
		method: "post",
		data
	})
}
export function apiKeyIdItemCodeList(data = {}) {
	return instance({
		url: "/aim/api/v3/item_code/keyId",
		method: "post",
		data
	})
}
export function apiMacItemCodeList(data = {}) {
	return instance({
		url: "/aim/api/v3/item_code/mac",
		method: "post",
		data
	})
}
export function apiTutkItemCodeList(data = {}) {
	return instance({
		url: "/aim/api/v3/item_code/tutk",
		method: "post",
		data
	})
}
export function apiH3cItemCodeList(data = {}) {
	return instance({
		url: "/aim/api/v3/item_code/h3c",
		method: "post",
		data
	})
}
export function apiNetIdItemCodeList(data = {}) {
	return instance({
		url: "/aim/api/v3/item_code/net_id",
		method: "post",
		data
	})
}
export function apiIflyTekItemCodeList(data = {}) {
	return instance({
		url: "/aim/api/v3/item_code/ifly_tek",
		method: "post",
		data
	})
}

//获取成品编码
export function getProductItemCodeList(data = {}) {
	return instance({
		url: "/aim/api/v3/item_code/product_itemCode",
		method: "post",
		data
	})
}

// 虚拟物料UUID--库存报表
export function apiUuidReport(data = {}) {
	return instance({
		url: "/aim/api/v3/uuid/report",
		method: "post",
		data
	})
}
export function apiUuidExport(data = {}) {
	return instance({
		url: "/aim/api/v3/uuid/export",
		method: "post",
		data
	})
}

// 虚拟物料UUID--uuid类别
export function apiUuidType(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/uuid_type",
		method: "post",
		data
	})
}

// 虚拟物料UUID--Key类型
export function apiP2PType(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/p2p_type",
		method: "post",
		data
	})
}

// 虚拟物料UUID--客户列表
export function apiCustomerList(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/list",
		method: "post",
		data
	})
}

// 虚拟物料UUID--上传MAC
export function apiUUIDUploadMac(data = {}) {
	return instance({
		url: "/aim/api/v3/uuid/upload/mac",
		method: "post",
		data
	})
}

// 虚拟物料UUID--上传NetId
export function apiUUIDUploadNetId(data = {}) {
	return instance({
		url: "/aim/api/v3/uuid/upload/net_id",
		method: "post",
		data
	})
}

// 虚拟物料UUID--上传IMEI
export function apiUUIDUploadIMEI(data = {}) {
	return instance({
		url: "/aim/api/v3/uuid/upload/imei",
		method: "post",
		data
	})
}
// 虚拟物料UUID--上传MAC
export function apiUUIDImportMac(data = {}) {
	return instance({
		url: "/aim/api/v3/uuid/import/mac",
		method: "post",
		data
	})
}
// 虚拟物料UUID--上传涂鸦UUID
export function apiUUIDUploadTuya(data = {}) {
	return instance({
		url: "/aim/api/v3/uuid/upload/tuya",
		method: "post",
		data
	})
}
export function apiUUIDUploadTutk(data = {}) {
	return instance({
		url: "/aim/api/v3/uuid/upload/tutk",
		method: "post",
		data
	})
}
export function apiUUIDUploadH3C(data = {}) {
	return instance({
		url: "/aim/api/v3/uuid/upload/h3c",
		method: "post",
		data
	})
}
export function apiUUIDUploadIflyTek(data = {}) {
	return instance({
		url: "/aim/api/v3/uuid/upload/ifly_tek",
		method: "post",
		data
	})
}
// 虚拟物料UUID--上传MyDlinkNum
export function apiUUIDUploadMyDLinkNum(data = {}) {
	return instance({
		url: "/aim/api/v3/uuid/upload/my_dlink_num",
		method: "post",
		data
	})
}

// 虚拟物料UUID--上传KeyId
export function apiUUIDUploadKeyId(data = {}) {
	return instance({
		url: "/aim/api/v3/uuid/upload/key_id",
		method: "post",
		data
	})
}